<template>
  <div>
    <div class="page-wrapper">
      <header class="header">
        <!-- End .header-top -->

        <div class="header-middle sticky-header clear-menu-header">
          <div class="container">
            <div class="header-left">
              <button class="mobile-menu-toggler" type="button">
                <i class="icon-menu"></i>
              </button>
              <a href="/" class="logo">
                <img src="/assets/images/logo.png" alt="Eurosan Logo">
              </a>
            </div><!-- End .header-left -->
          </div><!-- End .container -->
        </div><!-- End .header-middle -->

      </header><!-- End .header -->

      <main class="main home success-page">

        <div class="container">

          <div class="success-text-wrapper">
            <div class="icon-wrapper">
              <i class="sicon-check success-check"></i>
            </div>

            <p class="mt-1 alert" :class="alertClass">{{ message }}</p>

            <div class="success-btn-back">
              <router-link class="btn btn-primary" exact :to="{ name: route }">
                {{ translations.newsletterConfirm.backToShop }}
              <span v-if="showTime">({{ time }})</span>
              </router-link>
            </div>
          </div>
        </div><!-- End .container -->

      </main><!-- End .main -->
    </div><!-- End .page-wrapper -->

    <div class="mobile-menu-overlay"></div><!-- End .mobil-menu-overlay -->
  </div>
</template>
<script>
import api from '@/services/api';
import { translations } from '@/mixins';

export default {
  name: 'NewsletterConfirm',
  mixins: [translations],
  data() {
    return {
      time: 5,
      message: 'Molimo sačekajte',
      alertClass: 'alert-info',
      showTime: false,
    };
  },
  computed: {
    route() {
      const token = localStorage.getItem('token');

      return token ? 'Home' : 'Login';
    },
  },
  methods: {
    startTimer() {
      const timerId = setTimeout(() => {
        const token = localStorage.getItem('token');

        if (!token) {
          this.$router.push({ name: 'Login' });
        } else {
          this.$router.push({ name: 'Home' });
        }

        clearTimeout(timerId);
      }, this.time * 1000);

      const intervalId = setInterval(() => {
        if (this.time <= 1) {
          clearInterval(intervalId);
        }
        this.time -= 1;
      }, 1000);
    },
    confirmSubscription() {
      const payload = {
        ...this.$route.query,
      };
      api.confirmNewsletterSubscription(payload).then((response) => {
        this.message = response.data.info;
        this.alertClass = 'alert-success';
        this.showTime = true;
        this.startTimer();
      }).catch((err) => {
        this.message = err.response.data.info;
        this.alertClass = 'alert-danger';
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.confirmSubscription();
  },
};
</script>
<style lang="scss" scoped>
.success-page {
  height: calc(100vh - 73px);
}

.success-text-wrapper {
  width: 600px;
  height: 365px;
  background: white;
  /*padding: 20px;*/
  box-shadow: 0 12px 20px 0 rgb(0 0 0 / 8%);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.icon-wrapper {
  text-align: center;
  padding-top: 45px;
  padding-bottom: 45px;
  background: #58585b;
  color: #ffffff;
  margin-bottom: 30px;
}

.success-check {
  font-size: 64px;
}

.success-text-wrapper h1,
.success-text-wrapper p {
  text-align: center;
  font-weight: 400;
}

.success-btn-back {
  text-align: center;
  margin-top: 42px;
}

@media (max-width: 768px) {
  .success-text-wrapper {
    width: 350px;
  }
}
</style>
